


































































import { getCheckoutSessionData } from '@/api/api';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class DataRequestComponent extends Vue {
    @Prop({ type: Boolean, default: false }) disabled!: boolean;
    returnType: 'success' | 'echec' | null = null;

    frais = 15
    selected: any = {}
    offers = [
        {
            nb_data: 100,
            price: 150
        },
        {
            nb_data: 250,
            price: 350
        },
        {
            nb_data: 500,
            price: 650
        },
        {
            nb_data: 1000,
            price: 1200
        },
        {
            nb_data: 1500,
            price: 1650
        },
        {
            nb_data: 2000,
            price: 1750
        },
    ]

    created() {
        this.selected = this.offers[0]

        if (
            this.$route.params.slug === 'success' ||
            this.$route.params.slug === 'echec'
        ) {
            this.returnType = this.$route.params.slug;
        }
    }

    handleSelected(item: any) {
        console.log(item)
    }

    getItemTotalPrice(item: any) {
        return item.price + this.frais;
    }

    getItemUnitPrice(item: any) {
        return (item.price / item.nb_data).toFixed(2);
    }

    async checkout() {
        console.log(this.selected.price);
        const { data } = await getCheckoutSessionData(this.selected.price, this.selected.nb_data);
        //@ts-ignore    
        let stripe = Stripe(process.env.VUE_APP_STRIPE_KEY);
        stripe.redirectToCheckout({ sessionId: data });
        console.log(data);
    }
}
